import client from './client';

const Beneficiaries = {
  getBeneficiaries(anketId) {
    return client.get(`/ankets/${anketId}/kf_analytics/beneficiaries`);
  },
};

export default Beneficiaries;
